export default __webpack_public_path__ + "static/simulados-icon-b7efd754786ece6f001b3391042dcf63.svg";